module.exports = __webpack_public_path__ + "img/oldTwo.479e4cd6.png";